import { cloneElement, useState } from "react";
import { OverlayTrigger, OverlayTriggerProps } from "react-bootstrap";

interface Props extends OverlayTriggerProps {
  defaultShow?: boolean;
  closeDelay?: number;
}

const StickyOverlayTrigger = ({ children, ...props }: Props) => {
  const [showOverlay, setShowOverlay] = useState(props.defaultShow);

  const overlay = cloneElement(props.overlay as React.ReactElement, {
    onMouseEnter: () => setShowOverlay(true),
    onMouseLeave: () => {
      if (props.closeDelay) {
        setTimeout(() => setShowOverlay(false), props.closeDelay);
      } else {
        setShowOverlay(false);
      }
    },
  });

  return (
    <OverlayTrigger
      {...props}
      overlay={overlay}
      show={showOverlay}
      onToggle={(show) => setShowOverlay(show)}
    >
      {children}
    </OverlayTrigger>
  );
};

export default StickyOverlayTrigger;
